const ids = {};

ids.claimApplicationBankGroupId = '00000002-1fdd-49c5-99a2-000000000004';

ids.acceptedSurveyGroupId = '00000002-1fdd-49c5-99a2-000000000012';

ids.solicitorSurveyGroupId = '00000002-1fdd-49c5-99a2-000000000014';

ids.rejectedSurveyGroupId = '00000002-1fdd-49c5-99a2-000000000013';

ids.claimApplicationWithDrawnGroupId = '00000002-1fdd-49c5-99a2-000000000030';

ids.bankAccountTypeUkOption = '00000005-1fdd-49c5-99c2-000000000066';

ids.bankAccountTypeinternationalOption = '00000005-1fdd-49c5-99c2-000000000067';

ids.declarationQuestionGroupStep = '00000002-1fdd-49c5-99c2-000000000008';

ids.questionTypeIdCheckboxId = '00000003-1fdd-49c5-99c2-000000000009';

ids.currencyIdGBP = '00000001-1fdd-0024-99c2-000000000001';

ids.currencyIdEUR = '00000001-1fdd-0024-99c2-000000000002';
ids.currencyIdCAD = '00000001-1fdd-0024-99c2-000000000003';

export default ids;
